module.exports = __webpack_public_path__ + "static/75-41dbdf31e2d2a3ae7422b3d3a5153bd7.png";